module.exports = __webpack_public_path__ + "12a1afbbee0479b2caf757ea471d1c39.svg";